export const VERSION = '4.28.0'; // x-release-please-version
//# sourceMappingURL=version.mjs.map